import { FromConnectivePageComponent } from '@ag/sd.esign-visual-library/from-connective';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuardService as AuthGuard } from '../../modules/authentication/services/auth-guard.service';
import { AdviceNonhappyFlowComponent } from '../../modules/context/components/advice-nonhappy-flow/advice-nonhappy-flow.component';
import { BlockedComponent } from '../../modules/context/components/blocked/blocked.component';
import { ContextComponent } from '../../modules/context/components/context.component';
import { LoginAgnosticComponent } from '../../modules/context/components/login-agnostic/login-agnostic.component';
import { UnsubscribeComponent } from '../../modules/context/components/unsubscribe/unsubscribe.component';
import { RouteConstant } from '../../modules/e-sign/e-sign-routing.constant';
import { PersonDetailsResolverService } from '../../modules/identification/services/person-details-resolver.service';
import { GlobalBlockedComponent } from '../components/blocked/blocked.component';
import { ErrorScreenComponent } from '../components/error-screen/error-screen.component';
import { EsignHandlerComponent } from '../components/esign-handler/esign-handler.component';
import { ParamGuardService as ParamGuard } from '../services/param-guard.service';
import { DecommissionRedirectGuardService } from '../services/decommission-redirect-guard.service';
import { RouteNames } from './app-routing.constants';

export const routes = [
  {
    path: RouteNames.root,
    canActivateChild: [DecommissionRedirectGuardService],
    children: [
      { path: RouteNames.root, component: ContextComponent },
      { path: RouteNames.blocked, component: BlockedComponent },
      { path: `${RouteNames.blocked}/:blockedContext`, component: GlobalBlockedComponent },
      { path: `${RouteNames.blocked}/:blockedContext/:isAuthenticationRequired`, resolve: { userDetails: PersonDetailsResolverService }, canActivate: [AuthGuard], component: GlobalBlockedComponent },
      { path: RouteNames.unsubscribe, component: UnsubscribeComponent },
      { path: RouteNames.blockAdvice, component: AdviceNonhappyFlowComponent },
      { path: RouteNames.LoginAgnostic, component: LoginAgnosticComponent },
      // {
      //   path: `:productName/${RouteNames.simulation}`,
      //   canActivate: [ParamGuard],
      //   loadChildren: () => import('../../modules/simulation/simulation.module').then(m => m.SimulationModule)
      // },
      {
        path: `${RouteNames.simulation}`, // this path is there for broker flow
        canActivate: [ParamGuard],
        loadChildren: () => import('../../modules/simulation/simulation.module').then(m => m.SimulationModule)
      },
      {
        path: `${RouteNames.yongoSimulation}`,
        canActivate: [ParamGuard],
        loadChildren: () => import('../../modules/simulation/simulation.module').then(m => m.SimulationModule)
      },
      {
        path: `${RouteNames.identification}`,
        canActivate: [AuthGuard],
        resolve: { userDetails: PersonDetailsResolverService },
        loadChildren: () => import('../../modules/identification/identification.module').then(m => m.IdentificationModule)
      },
      // {
      //   path: `${RouteNames.identification}`,
      //   canActivate: [AuthGuard],
      //   resolve: { userDetails: PersonDetailsResolverService },
      //   loadChildren: () => import('../../modules/identification/identification.module').then(m => m.IdentificationModule)
      // }
      {
        path: `${RouteNames.needs}`,
        canActivate: [AuthGuard],
        resolve: { userDetails: PersonDetailsResolverService },
        loadChildren: () => import('../../modules/needs/needs.module').then(m => m.NeedsModule)
      },
      {
        path: `:sectionId/${RouteNames.surveyModule}`,
        canActivate: [AuthGuard],
        resolve: { userDetails: PersonDetailsResolverService },
        loadChildren: () => import('../../modules/survey/survey.module').then(m => m.SurveyModule)
      },
      {
        path: `:surveyCode/:sectionId/${RouteNames.surveyModule}`,
        // canActivate: [AuthGuard],
        // resolve: { userDetails: PersonDetailsResolverService },
        loadChildren: () => import('../../modules/survey/survey.module').then(m => m.SurveyModule)
      },
      {
        path: `:sectionId/${RouteNames.onBoarding}`,
        canActivate: [AuthGuard],
        resolve: { userDetails: PersonDetailsResolverService },
        loadChildren: () => import('../../modules/onboarding/onboarding.module').then(m => m.OnboardingModule)
      },
      {
        path: RouteNames.customerZone,
        canActivate: [AuthGuard],
        resolve: { userDetails: PersonDetailsResolverService },
        loadChildren: () => import('../../modules/customer-zone/customer-zone.module').then(m => m.CustomerZoneModule)
      },
      {
        path: RouteNames.authentication,
        loadChildren: () => import('../../modules/authentication/authentication.module').then(m => m.AuthenticationModule)
      },
      {
        path: `${RouteNames.eSign}`,
        loadChildren: () => import('../../modules/e-sign/e-sign.module').then(m => m.ESignModule)
      },
      {
        path: RouteNames.eSign + '/:signatureId/:status',
        loadChildren: () => import('../../modules/e-sign/e-sign.module').then(m => m.ESignModule)
      },
      {
        path: RouteConstant.fromConnective,
        canActivate: [AuthGuard],
        component: FromConnectivePageComponent
      },
      // {
      //   path: 'confirmation/:id/:status',
      //   redirectTo: `${RouteNames.eSign}/:id/:status`
      // },
      {
        path: 'confirmation/:id/:status',
        component: EsignHandlerComponent
      },
      {
        path: RouteNames.OnlinePayment,
        canActivate: [AuthGuard],
        loadComponent: () => import('../../modules/payment/components/online-payment/online-payment.component').then(m => m.OnlinePaymentComponent)
      },
      {
        path: RouteNames.ErrorScreen,
        component: ErrorScreenComponent
      },
      {
        path: RouteNames.ComeBackLater,
        component: ErrorScreenComponent
      },
      { path: RouteNames.any, redirectTo: RouteNames.root }
    ]
  }
] as Routes;

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
